import { LOGGED_OUT } from 'actions/types';
import { CREDIT_SCORE_GET_ENHANCED_FACTORS_FAILURE, CREDIT_SCORE_GET_ENHANCED_FACTORS_REQUEST, CREDIT_SCORE_GET_ENHANCED_FACTORS_SUCCESS, CREDIT_SCORE_RESET_DATA, } from '../actions/types';
const initialState = {
    data: {},
};
const enhancedFactorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT:
        case CREDIT_SCORE_RESET_DATA: {
            return initialState;
        }
        case CREDIT_SCORE_GET_ENHANCED_FACTORS_REQUEST: {
            return {
                ...state,
            };
        }
        case CREDIT_SCORE_GET_ENHANCED_FACTORS_SUCCESS: {
            const { factors, nextBestAction, nextBestActionId, nextBestActionDisplayTitle, } = action.payload;
            return {
                ...state,
                data: {
                    ...(nextBestAction && nextBestActionId
                        ? {
                            nextBestAction: {
                                id: nextBestActionId,
                                message: nextBestAction,
                                displayTitle: nextBestActionDisplayTitle,
                            },
                        }
                        : {}),
                    ...(factors ? { factors } : {}),
                },
            };
        }
        case CREDIT_SCORE_GET_ENHANCED_FACTORS_FAILURE: {
            return {
                ...state,
            };
        }
        default:
            return state;
    }
};
export default enhancedFactorsReducer;
